import {prefixPath} from "@rw/prefix_path";

import {CarMakes} from "./car_makes";

export const AGENCY_AND_DEVELOPERS_LOCATION_PATHS = [
    "bialystok",
    "bydgoszcz",
    "elblag",
    "gdansk",
    "gdynia",
    "gliwice",
    "katowice",
    "kielce",
    "kolobrzeg",
    "krakow",
    "legionowo",
    "lublin",
    "lodz",
    "olsztyn",
    "poznan",
    "rzeszow",
    "sopot",
    "swinoujscie",
    "szczecin",
    "torun",
    "warszawa",
    "wroclaw"
];

const LOCATION_STRING = AGENCY_AND_DEVELOPERS_LOCATION_PATHS.join("|");
/** URL path slugs only (no spaces) — `Alfa Romeo` → `alfaromeo`. */
const CAR_MAKES_STRING = Array.from(
    new Set(
        CarMakes.map((make) =>
            make
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-z0-9]+/g, "")
        ).filter(Boolean)
    )
).join("|");

export const appPath = prefixPath("/", {
    mainPage: "",
    aboutUs: "o-nas/",
    news: "news/",
    contact: "kontakt/",
    favourites: "ulubione/",
    seller: prefixPath("sprzedawca/", {
        base: "",
        detail: ":slug([\\w-]+)/"
    }),
    article: prefixPath("blog/", {
        base: "",
        detailOrCategoryList: ":slug([\\w-]+)/" // path handles both the article detail and list
    }),
    fullOffer: prefixPath("oferta/", {
        base: "",
        detail: prefixPath(":offerSlug([\\w-]+)-:carId([\\w-]+)/", {
            base: ""
        })
    }),
    offer: prefixPath("oferta/", {
        base: "",
        detail: prefixPath(":offerSlug([\\w-]+)-:carId([\\w-]+)/", {
            base: ""
        })
    }),
    page: prefixPath("strony/", {
        base: "",
        detail: ":slug([\\w-]+)/"
    }),
    search: "search/",
    searchResult: prefixPath(":offerType(osobowe|ciezarowe)/", {
        base: "",
        // location may be voivodeship OR model slug when make is present — disambiguated in parseOfferListPath
        universal: `:type(${CAR_MAKES_STRING})?/:location?/:subLocation?/:subSubLocation?/`,
        universalTag: `:type(${CAR_MAKES_STRING})?/:location?/:subLocation?/:subSubLocation?/tag/:tag/`
    }),
    admin: prefixPath("admin/", {
        login: "zaloguj/",
        register: "zarejestruj/",
        newPassword: "nowe-haslo/",
        userDashboard: prefixPath("panel/", {
            base: "",
            edit: "edytuj/:offerId([\\d]+)/"
        })
    })
});
